import http from 'plugins/axios';

export default {
    getNewsList(data) {
        return http.get({
            url: '/admin/news/list',
            data
        });
    },
    createNews(data) {
        return http.post({
            url: '/admin/news/add',
            data,
            dataType: 'form'
        });
    },
    updateNews(data) {
        return http.post({
            url: '/admin/news/update',
            data,
            dataType: 'form'
        });
    },
    removeNews(id) {
        return http.post({
            url: `/admin/news/delete/`,
            data: {"id": id},
            dataType: 'form'
        });
    },

};
